export default {"src":"/_next/static/image/assets/Illustrations/Logos.3db6dfe6fe98869feb0d4e4b3c6281ea.svg","height":574,"width":526};